module.exports = __webpack_public_path__ + "static/media/wifiLogo.c11a4117.png";